import Pantones from '../../../../components/editable-cell/form-items/pantones'
import type { ShipmentColumn } from '../../types/column-types'
import { onCellStandard } from '../../helpers/helpers'
import { RotatedTitle } from '../../../../components/rotated-title/rotated-title'
import { hasTaskOfType } from '../../helpers/has-task-of-type'

export const pantonesColumn: ShipmentColumn = {
    key: 'pantones',
    dataIndex: 'pantones',
    title: <RotatedTitle>Пантоны</RotatedTitle>,
    width: 30,
    editable: true,
    FormItem: <Pantones />,
    onCell: (record, index) => ({
        ...onCellStandard(record, index),
        editable: !hasTaskOfType(record, 'Заказ форм'),
    }) as any,
}
